import { useState } from "react";
import { login } from "../lib/auth";
import { useTheme } from "../hooks/useTheme";
import { Logo } from "../components/Logo";

interface Props {
  onSuccess: () => void;
}

export function Login({ onSuccess }: Props) {
  const [apelid, setApelid] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  const { theme, toggle } = useTheme();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro(null);
    setLoading(true);
    try {
      await login(apelid.trim(), senha);
      onSuccess();
    } catch (err) {
      setErro((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <button className="login-theme-toggle" onClick={toggle} title="Alternar tema">{theme === "light" ? "Modo escuro" : "Modo claro"}</button>

      <div className="login-card">
        <div className="login-brand">
          <Logo size={56} />
        </div>
        <div className="login-titulo">
          <h1>Painel de Produção</h1>
          <p>Entre com suas credenciais do sistema Formsteel</p>
        </div>

        <form onSubmit={submit} className="login-form">
          <label>
            <span>Usuário</span>
            <input
              type="text"
              value={apelid}
              onChange={(e) => setApelid(e.target.value)}
              autoComplete="username"
              autoFocus
              required
              placeholder="ex.: RICARDO"
            />
          </label>
          <label>
            <span>Senha</span>
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>

          {erro && <div className="login-erro">{erro}</div>}

          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>

        <div className="login-rodape">
          FORMSTEEL &copy; {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}
